import AvoirsLignesModel from "./AvoirsLignesModel";

class AvoirsModel {
    constructor(data) {
        this.id = data.id || null;
        this.facture_id = data.facture_id || null;

        this.numero = data.numero || null;
        this.date_emission = data.date_emission || null;
        this.statut = data.statut || "brouillon";

        this.titre = data.titre || null;
        this.notes_client = data.notes_client || null;
        this.notes_internes = data.notes_internes || null;

        this.sous_total_centimes = data.sous_total_centimes || 0;
        this.remise_centimes = data.remise_centimes || 0;
        this.tva_centimes = data.tva_centimes || 0;
        this.total_centimes = data.total_centimes || 0;

        this.acompte_centimes = data.acompte_centimes || 0;
        this.reste_du_centimes = data.reste_du_centimes || 0;

        this.type_paiement = data.type_paiement || null;
        this.devise = data.devise || "EUR";

        // Relations
        this.facture = data.facture || null;
        this.client = data.client || (data.facture?.client) || null;
        this.user = data.user || null;

        // Lignes typées
        this.lignes = data.lignes
            ? data.lignes.map((ligne) => new AvoirsLignesModel(ligne))
            : [];

        this.created_at = data.created_at || null;
        this.updated_at = data.updated_at || null;
        this.deleted_at = data.deleted_at || null;
    }

    // Retourne l'émetteur (user)
    get emetteur() {
        return this.user || null;
    }

    // Calcul du net à payer : facture TTC - avoir TTC
    get net_a_payer() {
        if (!this.facture) return this.total_centimes;
        return (this.facture.total_centimes || 0) - this.total_centimes;
    }
}

export default AvoirsModel;
